import { getApiURL, getSessionId } from 'utils/utils';
import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://localhost:9781',
  baseURL: getApiURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});
export const listUsers = (showUsersCountingAsSeat = false) =>
  instance.post(
    `/web-app/admin/workspaces/users/list`,
    {
      countAsASeat: showUsersCountingAsSeat,
    },
    {
      headers: {
        sessionId: getSessionId(),
      },
    }
  );

//  body('email').isEmail(),
//   body('sendInvitationEmail').isBoolean(),
//   body('firstName').isString().notEmpty().optional(),
//   body('lastName').isString().notEmpty().optional(),
//   body('jobTitle').isString().notEmpty().optional(),
//   body('managerId').isMongoId().optional(),
//   body('role').isIn(Object.values(ROLE)).optional(),
export const addUser = (params) =>
  instance.post(`/web-app/admin/workspaces/users/add`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });
export const bulkAddUsers = (params) => {
  const p = params.users?.map((user) => ({
    email: user.email,
    ...(user.profile?.profilePictureUrl && {
      profilePictureUrl: user.profile.profilePictureUrl,
    }),
    ...(user.profile.firstName && { firstName: user.profile.firstName }),
    ...(user.profile.lastName && { lastName: user.profile.lastName }),
    ...(user.profile.jobTitle && { jobTitle: user.profile.jobTitle }),
    ...(user.profile.managerId && { managerId: user.profile.managerId }),
    ...(user.slackUserId && { slackUserId: user.slackUserId }),
    sendInvitationEmail: params.sendInvitationEmail,
    role: 'USER',
  }));
  return instance.post(
    `/web-app/admin/workspaces/users/bulk-add`,
    { users: p },
    {
      headers: {
        sessionId: getSessionId(),
      },
    }
  );
};

export const updateUser = (params) =>
  instance.post(`/web-app/admin/workspaces/users/update`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });
export const inviteUser = (params) =>
  instance.post(`/web-app/admin/workspaces/users/invite`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

// name and tz
export const updateWorkspace = (params) =>
  instance.post(`/web-app/admin/workspaces/update`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

// remove slack workspace
export const removeSlackWorkspace = () =>
  instance.post(`/web-app/admin/workspaces/slack/remove`, undefined, {
    headers: {
      sessionId: getSessionId(),
    },
  });

// deactivate user
export const deactivateUser = (userId) =>
  instance.post(
    `/web-app/admin/workspaces/users/deactivate`,
    { userId },
    {
      headers: {
        sessionId: getSessionId(),
      },
    }
  );

export const reactivateUser = (userId) =>
  instance.post(
    `/web-app/admin/workspaces/users/reactivate`,
    { userId },
    {
      headers: {
        sessionId: getSessionId(),
      },
    }
  );

//list slack users
export const listSlackUsers = () =>
  instance.post(`/web-app/admin/workspaces/slack/list-users`, undefined, {
    headers: {
      sessionId: getSessionId(),
    },
  });

// /web-app/admin/workspaces/slack/sync
export const syncSlackWorkspace = () =>
  instance.post(`/web-app/admin/workspaces/slack/sync`, undefined, {
    headers: {
      sessionId: getSessionId(),
    },
  });
